import { CSSProperties, HTMLAttributes } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { HolderOutlined } from '@ant-design/icons';

interface DraggableRowProps extends HTMLAttributes<HTMLTableRowElement> {
  'data-row-key': string;
}

/** A `<tr>` that participates in dnd-kit sorting, keyed by the content item's id. */
const DraggableRow = ({ children, ...props }: DraggableRowProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: props['data-row-key'],
  });

  const style: CSSProperties = {
    ...props.style,
    transform: CSS.Translate.toString(transform),
    transition,
    ...(isDragging ? { position: 'relative', zIndex: 9999, background: '#fafafa' } : {}),
  };

  return (
    <tr {...props} ref={setNodeRef} style={style} {...attributes}>
      {Array.isArray(children)
        ? children.map((child, index) =>
            index === 0 ? (
              <td key="drag-handle" className="!p-0">
                <div className="flex items-center h-full px-4 py-2 cursor-grab active:cursor-grabbing" {...listeners}>
                  <HolderOutlined className="text-gray-400" aria-label="Drag to reorder" />
                </div>
              </td>
            ) : (
              child
            ),
          )
        : children}
    </tr>
  );
};

export default DraggableRow;
